module.exports = __webpack_public_path__ + "media/images/facebook-1e37d2f406b21270077b6067f50db9f1.png";